export default {
  OWNER: 'Shautt',
  OWNER_TAG: '%!OWNER!%',
  CONTACT: 'contact@shautt.com',
  CONTACT_TAG: '%!CONTACT!%',
  BRAND: 'Shautt',
  BRAND_TAG: '%!BRAND!%',
  GA_MEASUREMENT_ID: 'G-N9HY2L9BHY',
};
